<app-layout>
  <p-toast />

  <div class="home-element">
    <header>
      <h2>
        <i class="pi pi-clipboard"></i> Planes de Acción
      </h2>

      <div class="header-actions">
        <span class="view-selector">
          <button
            [class]="'view-selector-button border-primary text-primary ' + (activeView === 'kanban' ? 'view-selector-button-active bg-primary border-primary' : '')"
            (click)="toggleView('kanban')">
            <i class="pi pi-th-large" style="font-size: 1rem;"></i>
          </button>

          <button
            [class]="'view-selector-button border-primary text-primary ' + (activeView === 'table' ? 'view-selector-button-active bg-primary border-primary' : '')"
            (click)="toggleView('table')">
            <i class="pi pi-table" style="font-size: 1rem;"></i>
          </button>
        </span>

        <p-button (click)="addUpdateActionPlan(null)" type="button" icon="pi pi-plus" styleClass="p-button-rounded">
        </p-button>
      </div>
    </header>

    <div class="search-section">
      <p-iconField iconPosition="left">
        <p-inputIcon>
          <i class="pi pi-search"></i>
        </p-inputIcon>

        <input pInputText type="text" [value]="dataForm.value.search" (input)="onFilterInput($event, 'search')"
          placeholder="Buscar" />
      </p-iconField>

      <p-button (click)="resetFilters()" type="button" icon="pi pi-filter-slash" styleClass="p-button-rounded"
        severity="danger">
      </p-button>
    </div>

    <p-accordion>
      <p-accordionTab header="Filtrar planes de acción">
        <section class="filters-section" [formGroup]="dataForm">
          <div class="filters-group">
            <span class="p-fluid p-float-label">
              <p-autoComplete [(ngModel)]="dataForm.value.root_cause" [suggestions]="rootCauses"
                (completeMethod)="filterRootCause($event)" field="name" [dropdown]="true"
                (onSelect)="selectField($event, 'root_cause')" [forceSelection]="true" inputId="root_cause">
              </p-autoComplete>
              <label for="root_cause">Causa Raíz</label>
            </span>

            <span class="p-fluid p-float-label">
              <p-autoComplete [(ngModel)]="dataForm.value.qualification" [suggestions]="qualifications"
                (completeMethod)="filterQualification($event)" field="name" [dropdown]="true"
                (onSelect)="selectField($event, 'qualification')" [forceSelection]="true" inputId="qualification">
              </p-autoComplete>
              <label for="qualification">Calificación</label>
            </span>

            <span class="p-fluid p-float-label">
              <p-autoComplete [(ngModel)]="dataForm.value.event" [suggestions]="events"
                (completeMethod)="filterEvent($event)" field="title" [dropdown]="true"
                (onSelect)="selectField($event, 'event')" [forceSelection]="true" inputId="event">
              </p-autoComplete>
              <label for="event">Evento</label>
            </span>
          </div>
        </section>
      </p-accordionTab>
    </p-accordion>

    <ng-container *ngIf="activeView === 'table'; else kanban">
      <section class="table-container">
        <p-table #dt2 [value]="actionPlans" dataKey="id" [rows]="dataForm.value.page_size"
          [rowsPerPageOptions]="[10, 20, 30, 50]" [loading]="loading" [paginator]="false" styleClass="p-datatable-sm"
          currentPageReportTemplate="{currentPage} de {totalPages}" [globalFilterFields]="['']">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="folio" class="bg-gray-100 border-bottom">
                <p class="th-inside">
                  #Folio
                  <p-sortIcon field="folio" />
                </p>
              </th>

              <th pSortableColumn="event.title" class="bg-gray-100 border-bottom">
                <p class="th-inside">
                  Evento
                  <p-sortIcon field="event.title" />
                </p>
              </th>

              <th pSortableColumn="customer.name" class="bg-gray-100 border-bottom">
                <p class="th-inside">
                  Cliente
                  <p-sortIcon field="customer.name" />
                </p>
              </th>

              <th pSortableColumn="root_cause.name" class="bg-gray-100 border-bottom">
                <p class="th-inside">
                  Causa Raíz
                  <p-sortIcon field="root_cause.name" />
                </p>
              </th>

              <th pSortableColumn="qualification.name" class="bg-gray-100 border-bottom">
                <p class="th-inside">
                  Calificación
                  <p-sortIcon field="qualification.name" />
                </p>
              </th>

              <th pSortableColumn="description" class="bg-gray-100 border-bottom">
                <p class="th-inside">
                  Descripción
                  <p-sortIcon field="description" />
                </p>
              </th>

              <th class="bg-gray-100 border-bottom">
                <p class="th-inside">
                  Acciones
                </p>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-actionPlan>
            <tr class="text-sm">
              <td>
                <span class="folio">
                  {{ actionPlan.folio }}
                </span>
              </td>

              <td>
                <span class="table-text">{{ actionPlan.event?.title }}</span>
              </td>

              <td>
                {{ actionPlan.event?.customer?.name }}
              </td>

              <td>
                {{ actionPlan.root_cause?.name }}
              </td>

              <td>
                {{ actionPlan.qualification?.name }}
              </td>

              <td>
                <span class="table-text">{{ actionPlan.description }}</span>
              </td>

              <td>
                <div class="action-buttons">
                  <p-button (click)="viewTasks(actionPlan)" type="button" icon="pi pi-list"
                    styleClass="p-button-rounded p-button-text p-button-sm" pTooltip="Ver tareas" tooltipPosition="top">
                  </p-button>

                  <p-button (click)="addUpdateActionPlan(actionPlan)" type="button" icon="pi pi-pencil"
                    styleClass="p-button-rounded p-button-text p-button-sm" pTooltip="Editar" tooltipPosition="top">
                  </p-button>
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7">
                <p class="emptymessage">No se encontraron planes de acción</p>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <p-paginator [first]="dataForm.value.firstPage" [rows]="dataForm.value.page_size"
          [rowsPerPageOptions]="[10, 20, 30, 50]" [totalRecords]="dataForm.value.totalRecords"
          (onPageChange)="pageChange($event)" currentPageReportTemplate="{currentPage} de {totalPages}"
          [showJumpToPageDropdown]="true" [showPageLinks]="true" [showJumpToPageInput]="true"></p-paginator>
      </section>
    </ng-container>

    <ng-template #kanban>
      <div class="kanban-container">
        <div *ngFor="let column of kanbanColumns" class="kanban-list">
          <div class="list-header" [style]="{ 'border-top-color': column.color }">
            <h3>{{ column.title }}</h3>
            <p><strong>Número de planes: </strong>{{ column.total || 0 }}</p>
          </div>

          <section class="kanban-cards">
            <article *ngFor="let plan of column.plans" class="kanban-card">
              <header>
                <div class="kanban-card-info">
                  <h4 class="kanban-card-title">{{ plan.folio }}</h4>
                </div>

                <div class="kanban-card-actions">
                  <button pButton type="button" icon="pi pi-list" class="p-button-rounded p-button-text p-button-sm"
                    (click)="viewTasks(plan)" pTooltip="Ver tareas" tooltipPosition="top">
                  </button>

                  <button pButton type="button" icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-sm"
                    (click)="addUpdateActionPlan(plan)" pTooltip="Editar" tooltipPosition="top">
                  </button>
                </div>
              </header>

              <main>
                <p><strong>Evento:</strong> {{ plan.event?.title }}</p>
                <p><strong>Cliente:</strong> {{ plan.event?.customer?.name }}</p>
                <p><strong>Causa Raíz:</strong> {{ plan.root_cause?.name }}</p>
                <p><strong>Calificación:</strong> {{ plan.qualification?.name }}</p>
                <p class="plan-description" *ngIf="plan.description">
                  <strong>Descripción:</strong> {{ plan.description }}
                </p>
              </main>
            </article>

            <div *ngIf="column.loading" class="kanban-loading">
              <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
            </div>
          </section>

          <div *ngIf="column.currentPage < column.totalPages" class="kanban-load-more">
            <button type="button" (click)="loadMoreKanbanItems(column)" [disabled]="column.loading">
              <i class="pi pi-angle-down"></i>
              Cargar más
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</app-layout>